module.exports = __webpack_public_path__ + "img/phone.16e37819.svg";